
import React, { useEffect, useState } from 'react'
import { getIdData } from "../../../lib/studentinfo";


const StudentInfoPdf = ({slug}) => {
    const [studentInfo, setStudentInfo] = useState(0);
  
    async function GetData() {
      const std = await getIdData(slug);
      setStudentInfo(std);
    }
  
    useEffect(() => {
      GetData();
    }, []);
  
  return (
    <div
    className="checkout-form"
  >
    <div className="row m-2">
      <div className="col-6">
        <div className="form-group">
          <label className="form-control-label">Graduation Year</label>
          <p>{studentInfo ? studentInfo[0].graduateyear : ""}</p>
        </div>
      </div>
      <div className="col-6">
        <div className="form-group">
          <label className="form-control-label">GPA</label>
          <p>{studentInfo ? studentInfo[0].gpa : ""}</p>
        </div>
      </div>
      <div className="col-6">
        <div className="form-group">
          <label className="form-control-label">SAT / PSAT</label>
          <p>{studentInfo ? studentInfo[0].satpsat : ""}</p>
        </div>
      </div>
      <div className="col-6">
        <div className="form-group">
          <label className="form-control-label">Practice SAT</label>
          <p>{studentInfo ? studentInfo[0].statetest : ""}</p>
        </div>
      </div>
      <div className="col-6">
        <div className="form-group">
          <label className="form-control-label">Major</label>
          <p>{studentInfo ? studentInfo[0].major : ""}</p>
        </div>
      </div>
      <div className="col-6">
        <div className="form-group">
          <label className="form-label">Career</label>
          <p>{studentInfo ? studentInfo[0].career : ""}</p>
        </div>
      </div>
      <div className="col-6">
        <div className="form-group">
          <label className="form-label">Five Adjectives</label>
          <p>{studentInfo ? studentInfo[0].fiveAdjectives : ""}</p>
        </div>
      </div>
      <div className="col-6">
        <div className="form-group">
          <label className="form-label">About my High School</label>
          <p>
            {studentInfo ? studentInfo[0].hsSchoolStatistics : ""}
          </p>
        </div>
      </div>
      <div className="col-6">
        <div className="form-group">
          <label className="form-label">Top Three Colleges Choices</label>
          <p>{studentInfo ? studentInfo[0].topThreeColleges : ""}</p>
        </div>
      </div>
      <div className="col-6">
        <div className="form-group">
          <label className="form-label">Letter of Recommendation</label>
          <p>{studentInfo ? studentInfo[0].lor : ""}</p>
        </div>
      </div>
      <div className="col-6">
        <div className="form-group">
          <label className="form-label">Activities</label>
          <p>{studentInfo ? studentInfo[0].activities : ""}</p>
        </div>
      </div>
      <div className="col-6">
        <div className="form-group">
          <label className="form-label">College Essay</label>
          <p>{studentInfo ? studentInfo[0].collegeEssay : ""}</p>
        </div>
      </div>
      <div className="col-6">
        <div className="form-group">
          <label className="form-label">Counser&apos;s Comment</label>
          <p>{studentInfo ? studentInfo[0].instructorNote : ""}</p>
        </div>
      </div>
      <div className="col-6">
        <div className="form-group">
          <label className="form-label">Student&apos;s Comment</label>
          <p>{studentInfo ? studentInfo[0].studentNote : ""}</p>
        </div>
      </div>
    </div>
  </div>
  )
}

export default StudentInfoPdf